// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inner_list[data-v-f5a60642] {\n  list-style-type: circle;\n}", ""]);
// Exports
module.exports = exports;
